import React from 'react';
import './style.less';

class PipelineFloorBarTitle extends React.Component {
  constructor(props) {
    super(props);
  }

  formatTitle(title, maxChineseChars) {
    let result = '';
    let count = 0;
    for (let i = 0; i < title.length; i++) {
      const char = title[i];
      const isChinese = /[\u4e00-\u9fa5]/.test(char);
      const weight = isChinese ? 1 : 0.5;
      if (count + weight > maxChineseChars) break;
      result += char;
      count += weight;
    }
    return result;
  }

  render() {
    const { baseConfig } = this.props.config;
    const { moduleMarginTop, title, titleColor, titleStyle, leftImg, rightImg } = baseConfig;
    const displayTitle = this.formatTitle(title, 8);
    const leftImgUrl = titleStyle === '自定义样式' ? leftImg || '' : "https://static.shihuocdn.cn/admin/files/20260212/73b5a345869ec5fb7b07c89886278986.png";
    const rightImgUrl = titleStyle === '自定义样式' ? rightImg || '' : "https://static.shihuocdn.cn/admin/files/20260212/cb7616c822cbd5759718a8ef20ff8a64.png";
    return (
      <div 
        className="pipeline-floorBarTitle"
        id={this.props['customAttributes']['data-component-id']}
        {...this.props['customAttributes']}
        style={{
          marginTop: `${moduleMarginTop}px`
        }}
      >
        <div className="leftImg">
          <img src={leftImgUrl} alt="" />
        </div>
        <div className="title" style={{ color: titleColor || '#333333' }}>{displayTitle}</div>
        <div className="rightImg">
          <img src={rightImgUrl} alt="" />
        </div>
      </div>
    );
  }
}

export default PipelineFloorBarTitle;


// WEBPACK FOOTER //
// ./components/pipeline-floorBarTitle/index.js